import { i18n } from '@/plugins/i18n'

export default [
    {
        field: 'hashid',
        title: i18n.t('money_request.request_hashid'),
        sortable: true,
        width: 80,
        textAlign: 'center',
    },
    {
        field: 'payer_full_name',
        title: i18n.t('money_request.payer_name'),
        sortable: true,
        width: 120,
        textAlign: 'center',
    },
    {
        field: 'amount',
        title: i18n.t('money_request.price') + " (" + i18n.t('currency.rial') + ")",
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'description',
        title: i18n.t('money_request.description'),
        sortable: true,
        width: 150,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('money_request.created_at'),
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
    {
        field: 'status',
        title: i18n.t('money_request.status'),
        template: (row) => {
            let status  = moneyRequestStatus(row.status)
            let variant = 'badge-'+moneyRequestVariant(row.status)

            return '<div class="badge '+variant+' text-white">'+ status+'</div>'
        },
        sortable: true,
        width: 90,
        textAlign: 'center',
    },
]

export const moneyRequestVariant = (status) => {
    if(status == 'success')
        return 'success'
    else
        return 'warning'
}
export const moneyRequestStatus = (status) => {
    if(status == 'success')
        return i18n.t('money_request.succeed_payment')
    else
        return i18n.t('money_request.pending')
}
